import React from 'react'
import { Button } from '@material-ui/core'
import clsx from 'clsx'
import PropTypes from 'prop-types'

const TextLinkToDialogButton = ({ text, className, ...props }) => {
  return (
    <Button
      className={clsx(className, 'normal-case font-bold pt-0 pb-1 px-1')}
      color="secondary"
      {...props}
    >
      {text}
    </Button>
  )
}

TextLinkToDialogButton.propTypes = {
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.element,
  ]).isRequired,
  className: PropTypes.oneOf([PropTypes.string, PropTypes.object]),
}

export default TextLinkToDialogButton
